import 'slick-carousel';

const $doc = $(document);

$doc.on('change', '.js-product-option', function(event) {
  const selectedOptions = getSelectedOptionsString(event);
  updateVariantsSelect(selectedOptions);
  goToVariantImage(selectedOptions);
  updateDescription(selectedOptions);
});

const $productEnties = $('.js-entry-variant');
const $productEntiesDefault = $('.js-entry-variant[data-default]');
const $productEntryParent = $('.js-entry-parent');
const $optionsParent = $('.js-options');

/**
 * Update product description based on selected variant
 */
function updateDescription(option) {
  if ($productEnties && $productEntryParent && $productEntiesDefault) {
    $productEntryParent.find('.js-entry-variant.is-active').removeClass('is-active');
    const $entryTarget = $productEntryParent.find(`.js-entry-variant[data-title="${option}"]`)

    if ($entryTarget.text()) {
      $entryTarget.addClass('is-active');
      return;
    }

    $productEntiesDefault.addClass('is-active');
  }
}

/**
 * Initial product description based on selected variant
 */
 function initialDescription() {
  if ($optionsParent) {
    const $selectedOption = $optionsParent.find('input[type="radio"]:checked');
    if ($selectedOption) {
      const selectedOption = getSelectedOptionsString($selectedOption);
      updateDescription(selectedOption);
    }
  }
}

initialDescription();

/**
 * Get a string from the selected options in the pdp form
 * @return {string} selected options string
 */
function getSelectedOptionsString (event) {
  const selectedOptions = [];
  const $optionFields = $('.js-product-option');

  $optionFields.each((index, item) => {
    const selectedValue = item.value;

    if (item.type == 'radio') {
      if (item.checked) {
        selectedOptions.push(selectedValue);
      }

      return
    }

    selectedOptions.push(selectedValue);
  });

  const optionsString = selectedOptions.join('-');

  return optionsString
}

/**
 * Updates the variant selct with the current selected options
 *
 * @param  {String} selectedOptions a string with selected options
 */
function updateVariantsSelect(selectedOptions) {
  const $variantsSelect = $('.js-variants-select');
  const $option = $variantsSelect.find(`option[data-title-handle="${selectedOptions}"]`);
  const $btn = $variantsSelect.closest('form').find('.js-ajax-add')

  if ($option.length) {
    const value = $option.val();

    $variantsSelect.val(value);

    $variantsSelect.change();
  }
}

/**
 * Finds a slider image with the same [data-variant-label]
 * as the selected option value and slides to it
 * @param  {String} selectedOptions the selected option value
 * @return {}
 */
function goToVariantImage(selectedOptions) {
  const $slide = $(`.product__slider [data-variant-label="${selectedOptions}"]`);

  if ($slide.length === 0) {
    return
  }

  const slideIndex = $slide.closest('.slick-slide').data('slick-index');

  $('.js-product-slider').slick('slickGoTo', slideIndex);
}
